import { useMemo } from 'react';
import { RichTextViewer as QuillRichTextViewer, Card, Column } from 'seagull';
import { CalendarLiner24, DollarCircleLiner24, ReceiptEditLiner24New, ReceiptLiner24, NotesLiner24, ProfileTickLiner24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCobConfig } from "../../../../CobConfigContext";
import styles from "./AdditionalTerms.module.scss";
import { getAdditionalTermsData } from "./additionalTerms.utils";
import { TermItem } from "./TermItem";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetAdditionalTermsTID = () => getTestIds();
const iconMap = {
  effectiveDate: /*#__PURE__*/_jsx(CalendarLiner24, {}),
  paymentTerms: /*#__PURE__*/_jsx(DollarCircleLiner24, {}),
  amendments: /*#__PURE__*/_jsx(ReceiptEditLiner24New, {}),
  outOfScopeCharges: /*#__PURE__*/_jsx(ReceiptLiner24, {}),
  accountantAccess: /*#__PURE__*/_jsx(ProfileTickLiner24, {}),
  agreementNotes: /*#__PURE__*/_jsx(NotesLiner24, {})
};
const testIdMap = {
  effectiveDate: () => GetAdditionalTermsTID().AdditionalTermsTestIds.EffectiveDate(),
  paymentTerms: () => GetAdditionalTermsTID().AdditionalTermsTestIds.PaymentTerms(),
  amendments: () => GetAdditionalTermsTID().AdditionalTermsTestIds.Amendments(),
  outOfScopeCharges: () => GetAdditionalTermsTID().AdditionalTermsTestIds.OutOfScopeCharges(),
  accountantAccess: () => GetAdditionalTermsTID().AdditionalTermsTestIds.AccountantAccess(),
  agreementNotes: () => GetAdditionalTermsTID().AdditionalTermsTestIds.AgreementNotes()
};
export const AdditionalTerms = () => {
  const {
    relationship
  } = useCobConfig();
  const {
    AdditionalTermsTestIds
  } = useMemo(() => GetAdditionalTermsTID(), []);
  const termItems = useMemo(() => getAdditionalTermsData(relationship).map(item => ({
    icon: iconMap[item.key],
    title: item.title,
    description: item.key === 'agreementNotes' ? /*#__PURE__*/_jsx(QuillRichTextViewer, {
      className: styles.richTextNote,
      testId: "extra-clause-rich-text-viewer",
      value: item.description
    }) : item.description,
    testId: testIdMap[item.key]()
  })), [relationship]);
  return /*#__PURE__*/_jsx(Card, {
    className: styles.card,
    testId: AdditionalTermsTestIds.Card(),
    children: /*#__PURE__*/_jsx(Column, {
      gap: 20,
      children: termItems.map((item, idx) => /*#__PURE__*/_jsx(TermItem, {
        icon: item.icon,
        title: item.title,
        description: item.description,
        testId: item.testId
      }, idx))
    })
  });
};